import { useState } from "react";
import { Grid, List, ListItem, ListItemText, Paper, Button } from "@mui/material";
import { Modal } from "../../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../../components/common/Modal/ModalBody";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { SectionGeneralData } from "./SectionGeneralData";
import { SectionInventory } from "./SectionInventory";
import { SectionSpecificAttributes } from "./SectionSpecificAttributes";
import { SectionUses } from "./SectionUses";
import { SectionSpecificUses } from "./SectionSpecificUses";
import { SectionPrices } from "./SectionPrices";
import { useMediaQuery } from '@mui/material';
import { useProductStore } from "../../../../hooks/useProductStore";
import { readLocalStorage } from "../../../../toolbox/helpers/local-storage-helpers";
import { LocalStorageKey } from "../../../../types";
import '../../../../assets/styles/facturacionv3-app.css'
import { useProductImportStore } from "../../../../hooks/useProductImportStore";
import { SectionWarehouses } from "./SectionWarehouses";

/* nueva rama para laudus*/

type Values = {
    id: number,

    code: string, //imported
    code_erp: string, //product master
    code_system: string, //product master
    name: string,
    description: string,
    barcode: string,
    idcointype: number,
    idcategory: number,
    idsubcategory: number,
    idspecificsubcategory: number,
    idsupplier: number,
    idtype: number,

    idunitmeasure: number,
    idunitmeasureoptional: number,
    idbusinessarea: number,
    idclassification: number,
    minimumstock : number,
    maximumstock : number,

    idwarehouses: []|string,

    idattributes: string,
    idspecificattributes: string,
    iduses: string,
    idspecificuses: string,

    cost: number,
    price: number,
    alternativeprice: number,
    margin: number,
    offerprice: number,

    status: string,
}

const sections = [
    'Datos generales',
    'Inventario',
    'Almacen',
    // 'Atributos específicos',
    // 'Usos',
    // 'Usos específicos',
    'Precios',
];

export const ProductModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, productSelected, listproducts, imported, clearState } = props;

    const { action:actionproduct, createProduct, editProduct } = useProductStore();
    const { action:actionimported, editImportedProduct } = useProductImportStore();
    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const [loading, setLoading] = useState(false);
    const [currentSection, setCurrentSection] = useState<any>(0);

    const isSxSmMd = useMediaQuery('(min-width: 900px) and (max-width: 1536px)');

    const [data, setData] = useState<Values>({
        id: productSelected ? productSelected.id :'',

        code: productSelected ? productSelected.code :'', //product imported
        code_erp: productSelected ? productSelected.code_erp :'', //product master
        code_system: productSelected ? productSelected.code_system :'', // product system
        name: productSelected ? productSelected.name :'',
        description: productSelected ? productSelected.description :'',
        barcode: productSelected ? productSelected.barcode :'',
        idcointype: productSelected ? productSelected.idcointype :'',
        idcategory: productSelected ? productSelected.idcategory :'',
        idsubcategory: productSelected ? productSelected.idsubcategory :'',
        idspecificsubcategory: productSelected ? productSelected.idspecificsubcategory :'',
        idsupplier: productSelected ? productSelected.idsupplier :'',
        idtype: productSelected ? productSelected.idtype :'',

        idunitmeasure: productSelected ? productSelected.idunitmeasure :'',
        idunitmeasureoptional: productSelected ? productSelected.idunitmeasureoptional :'',
        idbusinessarea: productSelected ? productSelected.idbusinessarea :'',
        idclassification: productSelected ? productSelected.idclassification :'',
        minimumstock: productSelected ? productSelected.minimumstock :'',
        maximumstock: productSelected ? productSelected.maximumstock :'',

        idwarehouses: productSelected ? productSelected.idwarehouses :'',

        idattributes: productSelected ? productSelected.idattributes :'',
        idspecificattributes: productSelected ? productSelected.idspecificattributes :'',
        iduses: productSelected ? productSelected.iduses :'',
        idspecificuses: productSelected ? productSelected.idspecificuses :'',

        cost: productSelected ? productSelected.cost :'',
        price: productSelected ? productSelected.price :'',
        alternativeprice: productSelected ? productSelected.alternativeprice :'',
        margin: productSelected ? productSelected.margin :'',
        offerprice: productSelected ? productSelected.offerprice :'',

        status: productSelected ? productSelected.status :'',
    });

    // console.log(data)

    const handleSectionChange = (index) => {
        setCurrentSection(index);
    };
    const handleNextSection = () => {
        if (currentSection < sections.length - 1) setCurrentSection(currentSection + 1);
    };
    const handlePrevSection = () => {
        if (currentSection > 0) setCurrentSection(currentSection - 1);
    };
    const listItemStyle = {
        backgroundColor: '#1976d2',
        borderRadius: '10px',
        color: '#FFFFFF'
    };

    const onSubmit = async(dataProducts)  => {
        setLoading(true);

        if(productSelected){
            const response:any = await imported ? 
                editImportedProduct(productSelected.id, {...dataProducts, idcompany:idcompany}) : 
                editProduct(productSelected.id, {...dataProducts, idcompany:idcompany});
            if(response){
                listproducts && listproducts();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createProduct({...dataProducts, idcompany:idcompany});
            if(response){
                listproducts && listproducts();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <>
        
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="lg" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={productSelected ? 'Editar producto' : 'Nuevo producto'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody noscroll={isSxSmMd}>
                <Grid container display='flex' sx={{height: '100vh'}}>
                    <Grid xs={12} pr={2} md={2}>
                        <List component="nav">
                            {sections.map((section, index) => (
                                <ListItem
                                    button
                                    key={index}
                                    // onClick={() => handleSectionChange(index)}
                                    selected={index === currentSection}
                                    style={index === currentSection ? listItemStyle : {}}
                                >
                                <ListItemText primary={section} primaryTypographyProps={{style: { fontSize: '13px' }}}/>
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                    <Grid xs={12} md={10} sx={{border:'solid 1px #dad4d4', height: '85vh'}}>
                        <Grid sx={{padding:'10px 5px 5px 20px'}}>
                            {sections[currentSection]}
                        </Grid>

                        <TabContext value={currentSection.toString()}>
                            <TabPanel value='0' sx={{height:'95%'}}> 
                                { 
                                    <SectionGeneralData 
                                        dataGeneral={data}  
                                        setDataGeneral={setData}
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                        imported={imported}
                                        productSelected={productSelected}
                                        actionproduct={actionproduct}
                                        actionimported={actionimported}
                                    /> 
                                } 
                            </TabPanel>
                            <TabPanel value='1' sx={{height:'95%'}}> 
                                { 
                                    <SectionInventory
                                        dataInventory={data}  
                                        setDataInventory={setData}
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                        imported={imported}
                                        productSelected={productSelected}
                                        actionproduct={actionproduct}
                                        actionimported={actionimported}
                                    /> 
                                } 
                            </TabPanel>
                            <TabPanel value='2' sx={{height:'95%'}}> 
                                { 
                                    <SectionWarehouses
                                        dataWarehouse={data}  
                                        setDataWarehouse={setData}
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                        imported={imported}
                                        productSelected={productSelected}
                                        actionproduct={actionproduct}
                                        actionimported={actionimported}
                                    /> 
                                } 
                            </TabPanel>
                            {/* <TabPanel value='3' sx={{height:'95%'}}> 
                                { 
                                    <SectionSpecificAttributes
                                        dataSpecificAttributes={data}  
                                        setDataSpecificAttributes={setData}
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                        imported={imported}
                                        productSelected={productSelected}
                                        actionproduct={actionproduct}
                                        actionimported={actionimported}
                                    /> 
                                } 
                            </TabPanel> */}
                            {/* <TabPanel value='4' sx={{height:'95%'}}> 
                                { 
                                    <SectionUses
                                        dataUses={data}  
                                        setDataUses={setData}
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                        imported={imported}
                                        productSelected={productSelected}
                                        actionproduct={actionproduct}
                                        actionimported={actionimported}
                                    /> 
                                } 
                            </TabPanel> */}
                            {/* <TabPanel value='5' sx={{height:'95%'}}> 
                                { 
                                    <SectionSpecificUses
                                        dataSpecificUses={data}  
                                        setDataSpecificUses={setData}
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                        imported={imported}
                                        productSelected={productSelected}
                                        actionproduct={actionproduct}
                                        actionimported={actionimported}
                                    /> 
                                } 
                            </TabPanel> */}
                            <TabPanel value='3' sx={{height:'95%'}}> 
                                { 
                                    <SectionPrices
                                        dataPrices={data}  
                                        setDataPrices={setData}
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                        onSubmit={onSubmit}
                                        loadingsave={loading}
                                        imported={imported}
                                        productSelected={productSelected}
                                        actionproduct={actionproduct}
                                        actionimported={actionimported}
                                    /> 
                                } 
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </ModalBody>
            {/* <Grid xs={9} display='flex' justifyContent='end' sx={{padding:'10px 20px 10px 10px'}}>
                <Button size="small" variant="contained" 
                    onClick={handlePrevSection} 
                    disabled={currentSection === 0} 
                    sx={{marginRight:'2px', width:'150px', 
                        backgroundColor:'#f1a32d', color:'#FFFFFF',
                        '&:hover':{ backgroundColor:'#ff9700'}
                    }}>
                    Atrás
                </Button>
                <Button size="small" variant="contained" 
                    onClick={handleNextSection} 
                    disabled={currentSection === sections.length - 1} 
                    sx={{marginLeft:'2px', width:'150px',
                        backgroundColor:'#516E80', color:'#FFFFFF',
                        '&:hover':{ backgroundColor:'#445f70'}
                    }}>
                    Siguiente
                </Button>
            </Grid> */}
        </Modal>
      </>
    )
}